import React from 'react';

class Footer extends React.Component {
  render() {
    return ( 
      <footer className="footer">
        <div className="footer__cushion">
          <section className="footer__section footer__section--tertiary">          
          <nav className="footer__section__group footer__section__group--alpha">
              <h6 className="footer__section__group__headline">Why Zello?</h6>
              <ul className="
              footer__section__group__list
              footer__section__group__list--regular
          ">              <li className="
          footer__section__group__list__item
          footer__section__group__list__item--regular
      ">
                  <a className="footer__section__group__list__item__anchor" href="https://zello.com/product/frontline-communications/">
                    Frontline
                  </a>
                </li>
                <li className="
          footer__section__group__list__item
          footer__section__group__list__item--regular
      ">
                  <a className="footer__section__group__list__item__anchor" href="https://zello.com/product/dispatch/">
                    Dispatch
                  </a>
                </li>
                <li className="
          footer__section__group__list__item
          footer__section__group__list__item--regular
      ">
                  <a className="footer__section__group__list__item__anchor" href="https://zello.com/product/management/">
                    Management
                  </a>
                </li>
                <li className="
          footer__section__group__list__item
          footer__section__group__list__item--regular
      ">
                  <a className="footer__section__group__list__item__anchor" href="https://zello.com/solutions/upgrading-to-zello/">
                    Upgrading to Zello
                  </a>
                </li>            </ul>
            </nav>
            <nav className="footer__section__group footer__section__group--beta">
              <h6 className="footer__section__group__headline">Product</h6>
              <ul className="
              footer__section__group__list
              footer__section__group__list--regular
          ">              <li className="
          footer__section__group__list__item
          footer__section__group__list__item--regular
      ">
                  <a className="footer__section__group__list__item__anchor" href="https://zello.com/enterprise/">
                    Enterprise
                  </a>
                </li>
                <li className="
          footer__section__group__list__item
          footer__section__group__list__item--regular
      ">
                  <a className="footer__section__group__list__item__anchor" href="https://zello.com/solutions/">
                    Solutions
                  </a>
                </li>
                <li className="
          footer__section__group__list__item
          footer__section__group__list__item--regular
      ">
                  <a className="footer__section__group__list__item__anchor" href="https://zello.com/hardware/">
                    Hardware
                  </a>
                </li>
                <li className="
          footer__section__group__list__item
          footer__section__group__list__item--regular
      ">
                  <a className="footer__section__group__list__item__anchor" href="https://zello.com/pricing/">
                    Pricing
                  </a>
                </li>            </ul>
            </nav>
            <nav className="footer__section__group footer__section__group--gamma">
              <h6 className="footer__section__group__headline">Resources</h6>
              <ul className="
              footer__section__group__list
              footer__section__group__list--regular
          ">              <li className="
          footer__section__group__list__item
          footer__section__group__list__item--regular
      ">
                  <a className="footer__section__group__list__item__anchor" href="https://zello.com/developers/">
                    Developers
                  </a>
                </li>
                <li className="
          footer__section__group__list__item
          footer__section__group__list__item--regular
      ">
                  <a className="footer__section__group__list__item__anchor" href="https://zello.com/partners/">
                    Partners
                  </a>
                </li>
                <li className="
          footer__section__group__list__item
          footer__section__group__list__item--regular
      ">
                  <a className="footer__section__group__list__item__anchor" href="https://blog.zello.com/">
                    Blog
                  </a>
                </li>
                <li className="
          footer__section__group__list__item
          footer__section__group__list__item--regular
      ">
                  <a className="footer__section__group__list__item__anchor" href="https://zello.com/customers/">
                    Customers
                  </a>
                </li>
                <li className="
          footer__section__group__list__item
          footer__section__group__list__item--regular
      ">
                  <a className="footer__section__group__list__item__anchor" href="https://support.zellowork.com/">
                    Work Support
                  </a>
                </li>
                <li className="
          footer__section__group__list__item
          footer__section__group__list__item--regular
      ">
                  <a className="footer__section__group__list__item__anchor" href="https://support.zello.com/">
                    Personal Support
                  </a>
                </li>
                <li className="
          footer__section__group__list__item
          footer__section__group__list__item--regular
      ">
                  <a className="footer__section__group__list__item__anchor" href="https://zello.com/content/">
                    Resource Library
                  </a>
                </li>            </ul>
            </nav>
            <nav className="footer__section__group footer__section__group--delta">
              <h6 className="footer__section__group__headline">Company</h6>
              <ul className="
              footer__section__group__list
              footer__section__group__list--regular
          ">              <li className="
          footer__section__group__list__item
          footer__section__group__list__item--regular
      ">
                  <a className="footer__section__group__list__item__anchor" href="https://zello.com/about-us/">
                    About Us
                  </a>
                </li>
                <li className="
          footer__section__group__list__item
          footer__section__group__list__item--regular
      ">
                  <a className="footer__section__group__list__item__anchor" href="https://zello.com/careers/">
                    Careers
                  </a>
                </li>
                <li className="
          footer__section__group__list__item
          footer__section__group__list__item--regular
      ">
                  <a className="footer__section__group__list__item__anchor" href="https://zello.com/press/">
                    In the News
                  </a>
                </li>
                <li className="
          footer__section__group__list__item
          footer__section__group__list__item--regular
      ">
                  <a className="footer__section__group__list__item__anchor" href="https://zello.com/contact/">
                    Contact Us
                  </a>
                </li>            </ul>
            </nav>
            <nav className="footer__section__group footer__section__group--epsilon">
              <h6 className="footer__section__group__headline">Get the App</h6>
              <ul className="
              footer__section__group__list
              footer__section__group__list--regular
          ">              <li className="
          footer__section__group__list__item
          footer__section__group__list__item--regular
      ">
                  <a className="footer__section__group__list__item__anchor" href="https://zello.com/downloads/desktop/">
                    Desktop
                  </a>
                </li>
                <li className="
          footer__section__group__list__item
          footer__section__group__list__item--regular
      ">
                  <a className="footer__section__group__list__item__anchor" href="https://zello.com/downloads/android/">
                    Android
                  </a>
                </li>
                <li className="
          footer__section__group__list__item
          footer__section__group__list__item--regular
      ">
                  <a className="footer__section__group__list__item__anchor" href="https://zello.com/downloads/ios/">
                    iOS
                  </a>
                </li>            </ul>
            </nav>        </section>
          <section className="footer__section footer__section--quaternary">
            <nav className="footer__section__group footer__section__group--legalese">
              <ul className="
                      footer__section__group__list
                      footer__section__group__list--special
                  ">

                <li className="
          footer__section__group__list__item
          footer__section__group__list__item--verso
          footer__section__group__list__item--special
      ">
                  <a className="footer__brand" href="https://zello.com/" title="Go to the Zello home page"><svg width="86" height="15"
                      xmlns="http://www.w3.org/2000/svg">
                      <path
                        d="M15 0a2 2 0 012 2v1.992a1 1 0 01-.54.888L3.065 11.81a.1.1 0 00.045.19H17v3H2a2 2 0 01-2-2v-1.992a1 1 0 01.54-.888l13.395-6.93A.1.1 0 0013.89 3H0V0zm20 0v3H23l-2 2v1h14v3H21v1l2 2h12v3H22.828a2 2 0 01-1.414-.586l-2.828-2.828A2 2 0 0118 10.172V4.828a2 2 0 01.586-1.414L21.414.586A2 2 0 0122.828 0H35zm46.172 0a2 2 0 011.284.467l.13.119 2.828 2.828a2 2 0 01.578 1.239l.008.175v5.344a2 2 0 01-.467 1.284l-.119.13-2.828 2.828a2 2 0 01-1.239.578l-.175.008h-7.344a2 2 0 01-1.284-.467l-.13-.119-2.828-2.828a2 2 0 01-.578-1.239L69 10.172V4.828a2 2 0 01.467-1.284l.119-.13L72.414.586a2 2 0 011.239-.578L73.828 0h7.344zM41 0v12h11v3H40a2 2 0 01-2-2V0h3zm16 0v12h11v3H56a2 2 0 01-2-2V0h3zm24 3h-7l-2 2v5l2 2h7l2-2V5l-2-2z"
                        fill="currentColor" fillRule="evenodd" />
                    </svg></a>
                </li>
                <li className="
          footer__section__group__list__item
          footer__section__group__list__item--special
      ">
                  <a className="footer__section__group__list__item__anchor" href="https://zello.com/legal/privacy-policy/">
                    Privacy Policy
                  </a>
                </li>
                <li className="
          footer__section__group__list__item
          footer__section__group__list__item--special
      ">
                  <a className="footer__section__group__list__item__anchor" href="https://zello.com/legal/terms/">
                    Terms of Service
                  </a>
                </li>
                <li className="
          footer__section__group__list__item
          footer__section__group__list__item--special
      ">
                  <a className="footer__section__group__list__item__anchor" href="https://zello.com/legal/">
                    Legal
                  </a>
                </li>            </ul>
            </nav>
            <nav className="footer__section__group footer__section__group--mark">
              <ul className="
                      footer__section__group__list
                      footer__section__group__list--regular
                  ">

                <li className="
          footer__section__group__list__item
          footer__section__group__list__item--recto
          footer__section__group__list__item--regular
      ">
                  <a className="footer__brand" href="https://zello.com/" title="Go to the Zello home page"><svg width="86" height="15"
                      xmlns="http://www.w3.org/2000/svg">
                      <path
                        d="M15 0a2 2 0 012 2v1.992a1 1 0 01-.54.888L3.065 11.81a.1.1 0 00.045.19H17v3H2a2 2 0 01-2-2v-1.992a1 1 0 01.54-.888l13.395-6.93A.1.1 0 0013.89 3H0V0zm20 0v3H23l-2 2v1h14v3H21v1l2 2h12v3H22.828a2 2 0 01-1.414-.586l-2.828-2.828A2 2 0 0118 10.172V4.828a2 2 0 01.586-1.414L21.414.586A2 2 0 0122.828 0H35zm46.172 0a2 2 0 011.284.467l.13.119 2.828 2.828a2 2 0 01.578 1.239l.008.175v5.344a2 2 0 01-.467 1.284l-.119.13-2.828 2.828a2 2 0 01-1.239.578l-.175.008h-7.344a2 2 0 01-1.284-.467l-.13-.119-2.828-2.828a2 2 0 01-.578-1.239L69 10.172V4.828a2 2 0 01.467-1.284l.119-.13L72.414.586a2 2 0 011.239-.578L73.828 0h7.344zM41 0v12h11v3H40a2 2 0 01-2-2V0h3zm16 0v12h11v3H56a2 2 0 01-2-2V0h3zm24 3h-7l-2 2v5l2 2h7l2-2V5l-2-2z"
                        fill="currentColor" fillRule="evenodd" />
                    </svg></a>
                </li>

                <li className="
                          footer__section__group__list__item
                          footer__section__group__list__item--regular
                      ">
                  <small className="footer__subtle">
                    &copy; 2022 Zello Inc.
                  </small>
                </li>
              </ul>
            </nav>
          </section>
        </div>
      </footer>
    );
  }
}

export default Footer;



// WEBPACK FOOTER //
// ./src/Footer.js